export const subfolderLocaleCodeRegex = /^[a-z]{2}(-[A-Z]{2})?$/;

// We need this extra regex that requires language and country codes to distinguish between country only
// and language and country localized article paths
export const subfolderLocaleLanguageCountryCodeRegex = /^[a-z]{2}-[A-Z]{2}$/;

export const supportedSubfolderLocaleCodes = ['fr-FR', 'de-DE'];
